import { render, staticRenderFns } from "./PressReleases.vue?vue&type=template&id=008e1b0c&scoped=true"
import script from "./PressReleases.vue?vue&type=script&lang=js"
export * from "./PressReleases.vue?vue&type=script&lang=js"
import style0 from "./PressReleases.vue?vue&type=style&index=0&id=008e1b0c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e1b0c",
  null
  
)

export default component.exports